import { z } from "zod";

export const PASSWORD_MIN_LENGTH = 8;
// bcrypt ignores everything past 72 bytes, so a longer password would match
// any password sharing its first 72.
export const PASSWORD_MAX_LENGTH = 72;

// Sign-in accepts any length so passwords set before the minimum still work.
const signInPasswordZodString = z.string().min(1, "Password is required");

// Every password a user sets: sign-up, therapist invite and reset.
export const newPasswordZodString = z
  .string()
  .min(
    PASSWORD_MIN_LENGTH,
    `Password must be at least ${PASSWORD_MIN_LENGTH} characters`,
  )
  .max(
    PASSWORD_MAX_LENGTH,
    `Password must be at most ${PASSWORD_MAX_LENGTH} characters`,
  )
  .regex(/[A-Z]/, "Password must include an uppercase letter")
  .regex(/[0-9]/, "Password must include a number");

const emailZodString = z.string().trim().toLowerCase().email();

export const AuthSchema = z.object({
  email: emailZodString,
  password: signInPasswordZodString,
});

export type TAuthSchema = z.infer<typeof AuthSchema>;

export const NewAccountSchema = z.object({
  email: emailZodString,
  password: newPasswordZodString,
});

export const EmailSchema = z.object({
  email: emailZodString,
});

export type TEmailSchema = z.infer<typeof EmailSchema>;

export const NewPasswordSchema = z
  .object({
    password: newPasswordZodString,
    confirmPassword: signInPasswordZodString,
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords do not match",
  });

export type TNewPasswordSchema = z.infer<typeof NewPasswordSchema>;
